import { VehiclePickUp } from "@/components/booking/create/VehiclePickUp";

export default function Step4Screen() {
  return <VehiclePickUp route={true} />;
}
